import { Box, TextField, Typography } from '@mui/material';
import { MAX_PART_NUMBER_LENGTH, MAX_PART_NUMBERS } from './partNumberValidation';
import { ParsedPasteInput } from './parsePartNumbers';
import { IntakeSummary } from './IntakeSummary';

export interface PasteIntakeProperties {
  value: string;
  onChange: (value: string) => void;
  parsed: ParsedPasteInput;
  exceedsLimit: boolean;
}

export const PasteIntake = ({ value, onChange, parsed, exceedsLimit }: PasteIntakeProperties) => (
  <Box>
    <Typography variant='body2' color='text.secondary' sx={{ marginBottom: '12px' }}>
      Paste part numbers (NSN, NIIN, or manufacturer part number), one per line — up to {MAX_PART_NUMBERS}. Add an
      optional description after a comma: <code>part number, description</code>.
    </Typography>
    <TextField
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder={'813R250G01, hydraulic pump\n5841-01-528-4987\n9876-54-321-0987, spare valve'}
      multiline
      minRows={8}
      maxRows={16}
      fullWidth
      slotProps={{ htmlInput: { 'aria-label': 'Batch part numbers input', 'data-testid': 'batch-paste-input' } }}
    />
    <IntakeSummary>
      <span>{parsed.acceptedEntries.length} part numbers</span>
      {parsed.duplicatesRemoved > 0 && <span>{parsed.duplicatesRemoved} duplicates removed</span>}
      {parsed.emptyLines > 0 && <span>{parsed.emptyLines} empty lines</span>}
      {parsed.tooLong > 0 && (
        <span>
          {parsed.tooLong} too long (max {MAX_PART_NUMBER_LENGTH})
        </span>
      )}
      {exceedsLimit && (
        <Typography component='span' color='error.main' variant='body2'>
          Limit is {MAX_PART_NUMBERS}
        </Typography>
      )}
    </IntakeSummary>
  </Box>
);
